import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { ContractInterface, MifidCategoryCode, UserInterface } from '../../../../core';
import { DictionaryDialog } from '../../dialog/dictionary/dictionary.dialog';
import { PhoneDialog } from '../../dialog/phone/phone.dialog';

@Component({
    selector: 'thr-header-onboarding-client-portal',
    templateUrl: './header-onboarding-client-portal.component.html',
    styleUrls: ['./header-onboarding-client-portal.component.scss'],
})
export class HeaderOnboardingClientPortalComponent {
    public MifidCategoryCode: typeof MifidCategoryCode = MifidCategoryCode;

    @Input()
    contract: ContractInterface;

    @Input()
    user: UserInterface;

    @Input()
    showBack = false;

    @Input()
    showInfo = true;

    @Output()
    back: EventEmitter<boolean> = new EventEmitter();

    constructor(private dialog: MatDialog) {}
    onBack() {
        this.back.emit(true);
    }

    onDictionary() {
        this.dialog.open(DictionaryDialog);
    }

    onPhone() {
        this.dialog.open(PhoneDialog);
    }
}
